import { render, staticRenderFns } from "./TherapistDashModalAdminTimesList.vue?vue&type=template&id=58f05abd&scoped=true"
import script from "./TherapistDashModalAdminTimesList.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalAdminTimesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f05abd",
  null
  
)

export default component.exports